import { createEntityAdapter } from '@ngrx/entity';
import { SocieteProfilEntityState } from '@get/api-interfaces';
import { CustomEntityState } from '@get/store/configs/states';

export type IState = CustomEntityState<SocieteProfilEntityState>;

export const adapter = createEntityAdapter<SocieteProfilEntityState>({
  selectId: o => o.idSocieteProfil
});
export const initialState: IState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const societeProfilFeatureKey = 'societeProfil';
